__webpack_require__.p = "/jp/ja/appointment/";